import { render } from "./LocalSearch.vue?vue&type=template&id=bf752d40"
import script from "./LocalSearch.vue?vue&type=script&lang=js"
export * from "./LocalSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__